import { render } from "./403.vue?vue&type=template&id=30543cb6"
import script from "./403.vue?vue&type=script&lang=ts"
export * from "./403.vue?vue&type=script&lang=ts"

import "./403.vue?vue&type=style&index=0&id=30543cb6&lang=scss"
script.render = render

export default script